import { render, staticRenderFns } from "./file-source.vue?vue&type=template&id=28a7de4c"
import script from "./file-source.vue?vue&type=script&lang=js"
export * from "./file-source.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/mse/texting-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('28a7de4c')) {
      api.createRecord('28a7de4c', component.options)
    } else {
      api.reload('28a7de4c', component.options)
    }
    module.hot.accept("./file-source.vue?vue&type=template&id=28a7de4c", function () {
      api.rerender('28a7de4c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/audio/file-source.vue"
export default component.exports